var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_flexcol _gap-4" },
    [
      _vm._t("header"),
      _vm._v(" "),
      _c(
        "nav",
        {
          staticClass: "_flex _gap-2",
          attrs: { "data-qa": "backer-center-view-projects:ProjectTabs" },
        },
        _vm._l(_vm.tabs, function (tabType) {
          return _c(
            "base-tab",
            {
              key: tabType.key,
              attrs: {
                variant: "link",
                "is-active": tabType.isActive,
                "data-qa": `backer-center-view-projects-tab:${tabType.label}`,
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onTabClick(tabType.key)
                },
              },
            },
            [_vm._v("\n            " + _vm._s(tabType.label) + "\n        ")]
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }